import {ReactNode} from 'react';
import {Route} from 'react-router-dom';
import {PATHS, verificationTypesRoutes} from './constants';
import {IVQRGuard, IVDocumentTypeGuard, IVVerifiedContactsGuard} from 'components/guards';
import {IdentityVerificationLayout} from 'pages/IdentityVerification';
import {
  BackScanView,
  DocumentSelectionView,
  FrontScanView,
  StartView,
  IVQRScannerView,
  ContactsVerificationView,
  SelfieLivenessView,
  SelfieScanView,
} from 'pages/IdentityVerification/views';

type IVRoutesProps = {
  isLivenessDetectionEnabled?: boolean;
  children?: ReactNode;
};

function getIVRoutes({isLivenessDetectionEnabled, children}: IVRoutesProps) {
  return verificationTypesRoutes.map((route, index) => (
    <Route key={index} path={route} element={<IdentityVerificationLayout />}>
      <Route path={PATHS.verification.qrScan} element={<IVQRScannerView />} />

      <Route
        index
        element={
          <IVQRGuard>
            <StartView />
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.contacts}
        element={
          <IVQRGuard>
            <ContactsVerificationView />
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.documentSelection}
        element={
          <IVQRGuard>
            <IVVerifiedContactsGuard>
              <DocumentSelectionView />
            </IVVerifiedContactsGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.front}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <FrontScanView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.back}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <BackScanView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.selfie}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              {isLivenessDetectionEnabled ? <SelfieLivenessView /> : <SelfieScanView />}
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      {children}
    </Route>
  ));
}

export {getIVRoutes};
